// src/shared/constants/theme.ts
// RDC Board 2025 Figma Design Tokens (Typography, Spacing, Radius, Shadow)
// Update these values as needed from Figma

const typography = {
  fontFamily: 'Inter, Arial, sans-serif',
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  h1: { fontSize: 32, fontWeight: 700, lineHeight: '40px' },
  h2: { fontSize: 24, fontWeight: 700, lineHeight: '32px' },
  h3: { fontSize: 20, fontWeight: 600, lineHeight: '28px' },
  h4: { fontSize: 18, fontWeight: 600, lineHeight: '24px' },
  h5: { fontSize: 16, fontWeight: 600, lineHeight: '22px' },
  body1: { fontSize: 15, fontWeight: 400, lineHeight: '22px' },
  body2: { fontSize: 14, fontWeight: 400, lineHeight: '20px' },
  caption: { fontSize: 12, fontWeight: 400, lineHeight: '16px' },
};

const spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 40,
};

const radius = {
  sm: 4,
  md: 8,
  lg: 12,
  xl: 16,
  round: 9999,
};

const shadow = {
  sm: '0px 1px 2px rgba(16, 24, 40, 0.05)',
  md: '0px 2px 8px rgba(16, 24, 40, 0.10)',
  lg: '0px 4px 16px rgba(16, 24, 40, 0.12)',
};

const theme = {
  typography,
  spacing,
  radius,
  shadow,
};

export default theme;
export { typography, spacing, radius, shadow };
